<template>
  <div class="card-container elevation-3">
    <v-row>
      <v-col cols="12">
        <div class="card-title">
          Select Products
        </div>
      </v-col>
      <v-col cols="12">
        <SearchByTagsAndBrand
          v-model="query"
          append-icon="mdi-magnify"
          tags-width="300px"
          show-collection
          is-mobile
          compact
          @on-search="fetchProducts(true)" />
      </v-col>
      <v-col cols="12">
        <v-row
          ref="productsContainer"
          class="products-container">
          <v-col
            v-for="(product, index) in products"
            :key="`product-${index}`"
            cols="12">
            <ProductCard
              v-bind="product"
              can-select
              @select="onSelectProduct(product)" />
          </v-col>
          <v-col
            v-if="!products.length && !loading"
            cols="12"
            class="d-flex justify-center align-center"
            style="height: 224px;">
            <span style="color: #9c9c9c;">
              Oops! There is no product that matches your search criteria.
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SearchByTagsAndBrand from '@/components/SearchByTagsAndBrand.vue'
import ProductProvider from '@/resources/ProductProvider'
import ProductCard from './ProductCard.vue'

const ProductService = new ProductProvider()

const PLACEHOLDERS = Array.from({ length: 4 }, (_, i) => ({
  id: `loading-${i}`,
  loading: true
}))

export default {
  components: {
    SearchByTagsAndBrand,
    ProductCard
  },
  props: {
    selectedProducts: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: true,
      query: {
        search: '',
        brand: 'all',
        tags: [],
        tagOperation: 'OR',
        page: 1,
        itemsPerPage: 30,
        totalPages: 0,
        sortDesc: [true],
        sortBy: ['updatedAt']
      },
      products: [...PLACEHOLDERS]
    }
  },
  watch: {
    loading (val) {
      if (val) {
        this.products.push(...PLACEHOLDERS)
      } else {
        this.products = this.products.filter((p) => !p?.loading)
      }
    }
  },
  mounted () {
    this.fetchProducts(true)
    this.$refs.productsContainer.addEventListener('scroll', this.handleProductsScroll)
  },
  beforeDestroy () {
    this.$refs.productsContainer.removeEventListener('scroll', this.handleProductsScroll)
  },
  methods: {
    async fetchProducts (isClear = false) {
      try {
        this.loading = true

        if (isClear) {
          this.query.page = 1
          this.products = [...PLACEHOLDERS]
        }

        const { data } = await ProductService.getProductsForSorting(this.query)
        this.query.totalPages = data.pages
        this.products.push(...data.results)
      } catch (error) {
        console.error('fetchProducts', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `[GET-PRODUCT-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    handleProductsScroll (event) {
      const e = event.target
      const scrollY = e.scrollHeight - e.clientHeight - 100

      if (e.scrollTop >= scrollY && !this.loading && this.query.page < this.query.totalPages) {
        this.query.page++
        this.fetchProducts()
      }
    },
    onSelectProduct (product) {
      this.$emit('select', product)
    }
  }
}
</script>

<style scoped>
.card-container {
  padding: 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.625rem;
}
.h-full {
  height: 100%;
}
.products-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  min-height: 224px;
  max-height: calc(100vh - 364px);
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 2;
}
.card-title {
  font-weight: bold;
  font-size: 1.35rem;
}
</style>
